var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarBill = function SvgDollarBill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#66B4AD",
    fillRule: "evenodd",
    d: "M.727 5.134q11.25-.012 22.5.023.247.036.351.258.07 6.615-.047 13.219a.6.6 0 0 1-.304.164q-11.25.046-22.5 0a.43.43 0 0 1-.352-.258q-.046-6.562 0-13.125a.56.56 0 0 1 .352-.281",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#79CEC6",
    fillRule: "evenodd",
    d: "M4.664 6.772q7.387-.035 14.766.07a.54.54 0 0 1 .164.212q.319 1.806 2.133 2.132.152.06.21.211a142 142 0 0 1 0 5.156.33.33 0 0 1-.116.165q-1.934.349-2.274 2.273a.36.36 0 0 1-.258.164q-7.334.046-14.672 0-.345-.187-.304-.586-.471-1.472-1.992-1.758a.7.7 0 0 1-.258-.164 39 39 0 0 1-.07-2.672q-.012-1.341.07-2.671.321-.234.726-.258 1.386-.59 1.618-2.086a.52.52 0 0 1 .257-.188",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66B4AD",
    fillRule: "evenodd",
    d: "M11.508 8.369q2.958-.099 3.96 2.672.538 3.163-2.413 4.382-2.287.604-3.868-1.148-1.632-2.3 0-4.594a3.92 3.92 0 0 1 2.32-1.312",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#79CEC6",
    fillRule: "evenodd",
    d: "M11.789 9.586q.559-.085.586.468.56.162.68.727-.091.55-.61.328l-.281-.281q-.69-.153-.54.539.083.082.165.164 1.217.055 1.406 1.242-.072.786-.773 1.125-.086.555-.633.445a.56.56 0 0 1-.234-.445 1.3 1.3 0 0 1-.633-.562q-.045-.66.586-.493.21.41.656.282.375-.35 0-.703-1.782-.212-1.195-1.899.21-.316.562-.469a.7.7 0 0 1 .258-.468",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#66B4AD",
    fillRule: "evenodd",
    d: "M4.382 10.806q1.389-.198 1.594 1.172-.204 1.38-1.594 1.149-1.023-.51-.727-1.618.264-.462.727-.703M18.82 10.805q1.11-.19 1.524.844.169 1.353-1.172 1.5-1.126-.082-1.195-1.22.082-.822.843-1.124",
    clipRule: "evenodd"
  })));
};
export default SvgDollarBill;